(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["site-announcement"] && !Shopify.designMode) return;
  try {
    (function () {
    const COOKIE_NAME = 'site_announcement_dismissed';

    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    }

    function setCookie(name, value, days) {
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie =
        name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
    }

    function init() {
      const el = document.getElementById('site-announcement');
      if (!el) return;

      const key = el.dataset.announcementKey;
      if (getCookie(COOKIE_NAME) === key) return;

      el.classList.add('is-visible');

      el.querySelector('[data-announcement-close]').addEventListener('click', function () {
        el.classList.remove('is-visible');
        el.classList.add('is-closing');
        el.addEventListener(
          'animationend',
          function () {
            el.style.display = 'none';
            setCookie(COOKIE_NAME, key, 365);
          },
          { once: true }
        );
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
